export const ORG_SCOPED_ROUTE_PREFIX = '/organizations/';

export const isOnOrgScopedRoute = (pathname: string): boolean => pathname.startsWith(ORG_SCOPED_ROUTE_PREFIX);
